// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_DeletarCompromissoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/deletar_compromisso
 *
 * Validates input for deleting a compromisso.
 * Two code paths:
 * 1. Simple delete: only compromisso_id required
 * 2. With services: compromisso_id + orcamento_id + servicos all required
 */
import type { AgendaDeletarServicoNestedInput } from './AgendaDeletarServicoNestedInput'
import { registerContract } from './validate'

export interface Agenda_DeletarCompromissoInput {
compromisso_id: number
orcamento_id?: number
servicos?: AgendaDeletarServicoNestedInput[]
}

registerContract('Agenda_DeletarCompromissoInput', {
  compromisso_id: { type: 'number',  required: true },
  orcamento_id:   { type: 'number',  required: false },
  servicos: {
    type: 'array',
    required: false,
    items: {
      orcamento_servico_id: { type: 'number',  required: true },
    },
  },
})
